import { AddToChatButton } from "./AddToChatButton";

interface Props {
    selectedCount: number;
    onAskAbout: () => void;
}

export function DocumentsTaskAskButton({
    selectedCount,
    onAskAbout,
}: Readonly<Props>) {
    if (selectedCount === 0) {
        return null;
    }

    return (
        <AddToChatButton
            noun="document"
            count={selectedCount}
            onClick={onAskAbout}
        />
    );
}
